import { eEstadoMaestro } from "../common/enumModel";
import { IFilterCategoriaHipoModel } from "../interfaces/categoria-hipo/IFilterCategoriaHipoModel";

export class FilterCategoriaHipoModel implements IFilterCategoriaHipoModel {    
    idCategoriaHipo: number[];
    nombre: string;
    idEstado: eEstadoMaestro;
    page: number;
    pageSize: number;
    
    constructor(){
        this.idCategoriaHipo = new Array<number>();
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.page = 1;
        this.pageSize = 30;
    }
}